export default __webpack_public_path__ + "static/media/img_section6_starfish_full.a8641ea9.jpg";